// extracted by mini-css-extract-plugin
export default {"nav":"styles_nav__rIIxA","left":"styles_left__RxPZ8","menu":"styles_menu__3t+3M","right":"styles_right__RUvdX","logo":"styles_logo__XJMgc"};